import { Controller } from "@hotwired/stimulus"
import dropdown from "../tw-starter/dropdown";
import modal from "../tw-starter/modal";
import tab from "../tw-starter/tab";
import sideMenu from "../templatejs/side-menu"
import triggerIcons from '../templatejs/lucide'
import { createIcons, icons } from 'lucide';
import mobileMenu from '../templatejs/mobile-menu'
import tippy from 'tippy.js';
import { get } from '@rails/request.js'
import "@left4code/tw-starter/dist/js/svg-loader";
import "@left4code/tw-starter/dist/js/accordion";
import "@left4code/tw-starter/dist/js/alert";
import Toastify from "toastify-js";
import triggerTomSelect from '../templatejs/tom-select'
import "zoom-vanilla.js/dist/zoom-vanilla.min.js";
import "chartkick/chart.js"
// import "@left4code/tw-starter/dist/js/modal";
// import "@left4code/tw-starter/dist/js/tab";

// Connects to data-controller="side_navigation"
export default class extends Controller {
  static targets = ["notification", "refreshContent", 'changeClass', "refreshPage", "toggleClass", "tippy", "competition", 'colorTippy', 'turboDisabled', 'icon']


  connect() {
    sideMenu();
    // Create dropdown triggers
    dropdown();
    // Creating Icons
    triggerIcons();
    // Initialize the mobile menu
    mobileMenu();
    // Create modal triggers
    modal();
    // Create tab triggers
    tab();
  }

  turboDisabledTargetConnected(element){
  }

  changeClassTargetConnected(element){
    const targetId = element.dataset.id
    const changeClass = element.dataset.class
    const target = document.querySelector(`#${targetId}`)
    if(target){
      target.className = changeClass
    }
    element.remove();
  }

  competitionTargetConnected(element){
    element.dataset.color.split(' ').forEach(ele => {
      element.closest(".product_group").classList.add(ele)
    })
  }

  refreshPageTargetConnected(element) {
    element.remove()
    location.reload()
  }

  refreshContentTargetConnected(element) {
    triggerIcons();
    triggerTomSelect(document);
    element.remove()
  }

  toggleClassTargetConnected(element) {
    const target = element.dataset['target']
    const others = element.dataset['others']
    const className = element.dataset['class']

    if(className){
      if(others){
        document.querySelectorAll(others).forEach(el => {
          el.classList.remove(className);
        });
      }

      if(target){
        const item = document.querySelector(target)
        if(item){
          item.classList.add(className);
        }
      }

    }

    element.remove()
  }

  notificationTargetConnected(element){
    const elem = element.cloneNode(true)
    elem.classList.remove("hidden")
    delete elem.dataset.controller
    Toastify({
      node: elem,
      duration: 3000,
      newWindow: true,
      close: true,
      gravity: "bottom",
      position: "right",
      stopOnFocus: true,
  }).showToast();
  element.remove()
  }


  hiddenToggle(event){
    const target = event.target.dataset.hiddenToggleTarget
    let chevron = null
    if(event.target.dataset.chevron){
      chevron = event.target
    }else{
      chevron = event.target.querySelector('[data-chevron]')
    }
    if(target){
      const elements = document.querySelectorAll(target)
      const tr = event.target.closest("tr")

      if(tr){
        tr.classList.toggle("bg-slate-100")
      }

      if(elements){
        if(chevron){
          chevron.style.transition = "all 0.2s ease-in-out";
          chevron.classList.toggle("rotate-90")
          chevron.classList.toggle("text-slate-300")
        }
        elements.forEach(element => {
          element.classList.toggle("hidden")
        });
      }
    }
  }

  tippyTargetConnected(element){
    tippy(element, {
      content: element.dataset.title,
    });
    triggerIcons();
  }

  colorTippyTargetConnected(element){
    tippy(element, {
      content: element.dataset.title,
    });
  }

  openDropdown(event){
    const myDropdown = tailwind.Dropdown.getOrCreateInstance(event.target.parentElement);
    myDropdown.toggle();
  }

  close(event){
    event.target.parentElement.remove()
  }

  changeSessionValue(event){
    get("/tools/change_session_value", {responseKind: "turbo-stream", query: {key: event.target.dataset.attribute, value: event.target.value, name: event.target.options[event.target.selectedIndex].text}})
  }

  accordionToggle(event){
    const targetId = event.currentTarget.dataset.target
    const target = document.querySelector(`#${targetId}`)
    const arrow = event.currentTarget.querySelector('.accordion-arrow')
    if(target){
      // target.classList.toggle('hidden')
      target.classList.toggle('h-full')
      if(arrow){
        arrow.classList.toggle('rotate-180')
        arrow.classList.toggle('text-gray-300')
        arrow.classList.toggle('text-gray-900')
      }
    }
  }

  showDropdown(){
  }

  hideDropdown(){

  }

}
